import React, { useEffect, useState, useContext } from "react";
import classes from "./PrintSalesReceipt.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { UserProvider, useUser } from "../../UserContext.js";

const PrintSalesReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useUser();

  // const vat = total * 0.075;
  const discount = 0;
  // const grandTotal = total + vat - discount;

  const searchParams = new URLSearchParams(location.search);
  const modeFromQuery = searchParams.get("mode");
  const modeFromState = location.state?.mode;
  const { result, responseData, invoice: invoiceFromState } = location.state || {};
  const invoice = invoiceFromState || result || responseData || {};

  console.log(invoice, "fullinvoice");
  const isPOS = (modeFromState || modeFromQuery || "pos") === "pos";

  const {
    company,
    currency,
    customer_id,
    invoice_number,
    created_at,
    description,
    sales = [],
    sub_total,
    total_discount,
    total_vat,
    total_wht,
    total_price,
    transaction_date,
  } = invoice || {};


  const getBackendDescription = (value, fallback = "") => {
    const candidates = [
      value?.description,
      value?.message,
      value?.data?.message,
      value?.item_description,
      value?.item?.description,
      value?.item_name,
      value?.name,
      value?.product_name,
      value?.product?.name,
      value?.item?.name,
      value?.sales_description,
      fallback,
    ];

    return candidates.find((candidate) => {
      if (candidate === undefined || candidate === null) return false;
      return String(candidate).trim() !== "";
    }) || "";
  };

  // Prefer the invoice-level description (saved description) first,
  // then fall back to the first item's description or other candidates.
  const selectedDescription =
    (description && String(description).trim()) ||
    (invoice?.description && String(invoice.description).trim()) ||
    getBackendDescription(invoice?.sales?.[0], "") ||
    "—";

  if (!location.state) {
    return (
      <div className={classes.errorPage}>
        <h2>Invoice data not found.</h2>
        <button onClick={() => navigate("/dashboard")}>Go to Dashboard</button>
      </div>
    );
  }

  console.log(result);

  const fmtMoney = (n) => {
    const num = Number(n || 0);
    try {
      const code = currency?.symbol;
      return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(num);
    } catch {
      return `${currency?.symbol ?? ""}${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  };

  const StarRule = () => (
    <div className={classes.starRule} aria-hidden="true">
      {Array.from({ length: 44 }).map(() => "*").join("")}
    </div>
  );

  const printInvoice = () => {
    window.print();
  };

  return (
    <UserProvider>
    <div>
      <HeaderNav className={classes.noPrint} />
      <div className={classes.page}>
        <button onClick={printInvoice} className={`${classes.printBtn} ${classes.noPrint}`}>
          🖨 Print
        </button>
       <div className={`${classes.paper} printSheet`}>
          <header className={classes.header}>
            <h1 className={classes.shopName}>{user?.company?.name || "SHOP NAME"}</h1>
            <div className={classes.muted}>
              {user?.company?.address && <div>{user?.company?.address}</div>}
              {user?.company?.phone_number && <div>Tel: {user?.company?.phone_number}</div>}
            </div>
            <div style={{ marginTop: 10 }} />
            <StarRule />
            <div className={classes.title}>CASH RECEIPT</div>
            <StarRule />
          </header>
          <section className={classes.meta}>
            <div className={classes.metaRow}>
              <span className={classes.metaLabel}>Receipt #</span>
              <span className={classes.metaValue}>{ invoice?.invoice_number}</span>
            </div>
            <div className={classes.metaRow}>
              <span className={classes.metaLabel}>Date</span>
              <span className={classes.metaValue}>{ invoice?.transaction_date}</span>
            </div>
            {invoice?.customer_id && (
              <div className={classes.metaRow}>
                <span className={classes.metaLabel}>Customer</span>
                <span className={classes.metaValue}>{invoice?.customer_id}</span>
              </div>
            )}
            <div className={classes.metaRow}>
              <span className={classes.metaLabel}>Description</span>
              <span className={classes.metaValue}>{selectedDescription}</span>
            </div>
          </section>
          <StarRule />
          <section className={classes.items}>
            <table className={classes.table}>
              <colgroup>
                <col className={classes.colItem} />
                <col className={classes.colPrice} />
                <col className={classes.colAmount} />
              </colgroup>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Price</th>
                  <th style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
              {(invoice?.sales || []).map((item, index) => {
                  const name = getBackendDescription(item, selectedDescription) || "—";
                  const qty = Number(item?.quantity || 0);
                  const unitPrice = Number(item?.item?.price || 0);
                  const lineTotal = Math.max(unitPrice * qty, 0);

                  return (
                    <tr key={item.id || index}>
                      <td>
                        <span className={classes.truncate}>{qty}x {name}</span>
                      </td>
                      <td>
                        <span className={`${classes.truncate} ${classes.num}`}>{fmtMoney(unitPrice)}</span>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <span className={`${classes.truncate} ${classes.num}`}>{fmtMoney(lineTotal)}</span>
                      </td>
                    </tr>
                  );
                })}

              </tbody>
            </table>

            {/* <div className={classes.salesList}>
     
            <div className={classes.salesHeader}>
              <p>Item</p>
              <p>Price</p>
              <p>Amount</p>
            </div>

          
            {(invoice?.sales || []).map((item, index) => {
              const name = item?.item?.name ?? `Item ${index + 1}`;
              const qty = Number(item?.quantity || 0);
              const unitPrice = Number(item?.item?.price || 0);
              const lineTotal = Math.max(unitPrice * qty, 0);

              return (
                <div>
                <div key={item.id || index} className={classes.salesRow}>
                  <p className={classes.truncate}>
                    {qty}x {name}
                  </p>
                  <p className={`${classes.truncate} ${classes.num}`}>
                    {fmtMoney(unitPrice)}
                  </p>
                  <p className={`${classes.truncate} ${classes.num}`}>
                    {fmtMoney(lineTotal)}
                  </p>
                </div>
                </div>
              );
            })}
          </div> */}
          </section>
          <StarRule />
          <section className={classes.totals}>
            <div className={classes.totalRow}><span>Discount</span><span>{fmtMoney(invoice?.total_discount)}</span></div>
            <div className={classes.totalRow}><span>Subtotal</span><span>{fmtMoney(invoice?.sub_total)}</span></div>
            <div className={classes.totalRow}><span>VAT</span><span>{fmtMoney(invoice?.total_vat)}</span></div>
            <div className={classes.totalRow}><span>WHT</span><span>{fmtMoney(invoice?.total_wht)}</span></div>
            <div className={`${classes.totalRow} ${classes.grand}`}><span>Total</span><span>{fmtMoney(invoice?.total_price)}</span></div>
          </section>
          <StarRule />
          <footer className={classes.footer}>
            <div className={classes.thanks}>THANK YOU!</div>
          </footer>
        </div>
      </div>
      <div className={classes.noPrint}><Footer /></div>
    </div>
    </UserProvider>
  );
};

export default PrintSalesReceipt;